<template>
	<div :class="['porlet-grafica', {'error': error}]" v-loading="loading">

        <template v-if="error">
            <el-alert
                title="Error al obtener datos"
                type="error"
                :closable="false">
            </el-alert>
        </template>

        <template v-else-if="chartOptions && series" >

            <div class="title" v-if="title">
                <p>{{title}}</p>
            </div>

            <apexchart
                :type="type" 
                :width="width" 
                :height="height"
                :options="chartOptions" 
                :series="series"/>
        </template>

    </div>
</template>

<script>
    import VueApexCharts from 'vue-apexcharts'

    import {
        getGraficaDatos
    } from '@/helpers/api'

	export default {
        name: 'Grafica',
        components: {
            apexchart: VueApexCharts
        },
        props: {
            entidadRelacionada: {
                type: String,
                required: false
            },
            url: {
                required: false
            },
            type: {
                type: String,
                required: true
            },
            width: {
                type: String,
                required: false,
                default: '100%'
            },
            height: {
                type: String,
                required: false,
                default: '400px'   
            },
            title: {
                type: String,
                required: false
            }
        },
		data () {
            return {
                error: null,
                loading: false,
                series: null,
                chartOptions: null
            }
        },
        mounted() {
            this.init()
            this.$emit('created')
        },
        methods: { 
            async init() {
                this.error = false
                this.series = []
                await this.getData()
            },
            async getData(filtro = []) {
                
                if(!this.$attrs.porlet.attr.visible) return

                this.loading = true

                try {

                    //resp = await getGraficaDatos(this.entidadRelacionada)

                    await new Promise(resolve => setTimeout(resolve, Math.floor((Math.random() * 3000) + 500) ));

                    const resp = await (await fetch(`${this.url}?${this.serialize(filtro)}`, {
						method: 'GET'
					})).json()

                    if (resp.status == 200 && typeof resp.data == 'object') {

                        this.chartOptions = resp.data.chartOptions
                        let _self = this
                        this.chartOptions.chart.events = {
                            dataPointSelection: async function(event, chartContext, { seriesIndex, dataPointIndex, config}) {

                                console.log('dataPointSelection', seriesIndex, dataPointIndex)

                                _self.loading = true

                                // 1. Peticion de filtro a back
                                await new Promise(resolve => setTimeout(resolve, 1000 ));

                                /*const resp = await (await fetch(`${this.url}?${this.serialize(filtro)}`, {
                                    method: 'GET'
                                })).json()*/

                                // 1.1 Oculto grafica actual
                                _self.$referencias.grafica.find(f => f.$attrs.porlet.id == _self.$attrs.porlet.id).$attrs.porlet.attr.visible = false

                                // 1.2 Muestro el componente que me indique el back: Ejemplo la "grafica" con id "3"
                                const resp_demo = {
                                    id: 3,
                                    type: "grafica",
                                    filtro: [{
                                        foo: 2
                                    }]
                                }
                                _self.$referencias[resp_demo.type].find(f => f.$attrs.porlet.id == resp_demo.id).reloadContent(resp_demo.filtro)

                                _self.loading = false
                            }
                        }
                        
                        this.series = resp.data.series
                        
                    } else {
                        this.error = true
                    }

                } catch(err) {
                    this.error = true
                }

                this.loading = false
                
            },
            reloadContent(filtro) {

                //chart.$attrs.porlet.attr.visible = true
                this.$attrs.porlet.attr.visible = true
                this.getData(filtro)

            },
            serialize(array) {
                var str = [];
                array.forEach((o) => {
                    var key = Object.keys(o)
                    str.push(key + "=" + o[key]);
                })
                return str.join("&");
            }
            // Volver a la grafica de origen
            /*goBackOrigin() {

                // Oculto grafica actual
                this.$referencias.grafica.find(f => f.$attrs.porlet.id == this.$attrs.porlet.id).$attrs.porlet.attr.visible = false

                // Muestro grafica de origen
                this.$referencias.grafica.find(f => f.$attrs.porlet.id == this.origin).$attrs.porlet.attr.visible = true
            }*/
        }
	}
</script>

<style lang="scss">
.porlet-grafica {
    min-height: 300px!important;
    background-color: white;
    padding: 20px;
    border-radius: 4px;
    //box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065);
    margin-bottom: 20px;
    &.error {
        min-height: auto!important;
    }
    .title {
        display: flex;
        p {
            margin: 0px;
            &.origin {
                cursor: pointer;
                padding-right: 5px;
            }
        }
    }
}
</style>